import React, { useEffect } from "react";
import { Box, Typography, Grid, Card, CardContent, CardActionArea, Button } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import { useNavigate } from "react-router-dom";


const products = [
    {
        name: "Jeerakasala rice",
        country: "India",
        icon: "https://i.postimg.cc/7YjrBKSK/image-9-removebg-preview.png"
    },
    {
        name: "Honey",
        country: "Indonesia",
        icon: "https://i.postimg.cc/x1HLwcs3/image.png"
    },
    {
        name: "Lemon Pickle",
        country: "India",
        icon: "https://i.postimg.cc/v8fM6ySS/image.png"
    },
    {
        name: "Olive Oil",
        country: "India",
        icon: "https://i.postimg.cc/cC1QY7DW/image-12-removebg-preview.png"
    },
    {
        name: "Mixed Veg Pickle",
        country: "India",
        icon: "https://i.postimg.cc/v8fM6ySS/image.png"
    },
    {
        name: "Mango Pickle",
        country: "India",
        icon: "https://i.postimg.cc/v8fM6ySS/image.png"
    },
    {
        name: "Olive oil (L)",
        country: "India",
        icon: "https://i.postimg.cc/cC1QY7DW/image-12-removebg-preview.png"
    },
    {
        name: "Matta Short Again",
        country: "India",
        icon: "https://i.postimg.cc/7YjrBKSK/image-9-removebg-preview.png"
    },
    {
        name: "Ponni Rice",
        country: "India",
        icon: "https://i.postimg.cc/7YjrBKSK/image-9-removebg-preview.png"
    },
    {
        name: "Kuruva Rice",
        country: "India",
        icon: "https://i.postimg.cc/7YjrBKSK/image-9-removebg-preview.png"
    },
    {
        name: "Jaya Rice",
        country: "India",
        icon: "https://i.postimg.cc/7YjrBKSK/image-9-removebg-preview.png"
    },
];

const features = [
    { icon: "🏆", label: "Best quality" },
    { icon: "🤝", label: "100% Trusted" },
    { icon: "🛡️", label: "Hygiene" },
];

const ImportedFoodProducts = () => {

    const navigate=useNavigate();

    const handleViewMoreClick = () => {
      navigate('/sonxproducts'); // Ensure this route exists in your router
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
        });
    }, []);

    return (
        <Box sx={{ padding: 4, textAlign: "center" }}>
            <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "#6A983C", mb: 4,fontFamily: '"Montserrat", sans-serif', }}
                data-aos="fade-up"
            >
                Our Imported Food Products
            </Typography>

            <Grid container spacing={3}>
                {products.map((product, index) => (
                    <Grid item xs={6} sm={6} md={3} key={index} data-aos="fade-up" data-aos-delay={`${index * 200}`}>
                    <Card
                            sx={{
                                backgroundColor: product.highlight ? "#6A983C" : "#fff",
                                color: product.highlight ? "#fff" : "#333",
                                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
                                transition: "transform 0.3s ease-in-out",
                                border: "1px solid black",
                                "&:hover": {
                                    transform: "scale(1.05)",
                                    backgroundColor: "#6A983C",
                                    color: "#fff",
                                },
                                borderTopRightRadius: "16px",
                                borderBottomLeftRadius: "16px",
                                borderTopLeftRadius: "0px",
                                borderBottomRightRadius: "0px",
                               
                            }}
                        >
                            <CardActionArea>
                                <CardContent
                                    sx={{
                                        textAlign: "left",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 1,
                                    }}
                                >
                                    <Box sx={{ textAlign: "left" }}>
                                        <img
                                            src={product.icon}
                                            alt={product.name}
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                objectFit: "contain",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    </Box>
                                    <Typography
                                        variant="h5"
                                        sx={{ fontSize: "24px", mt: 2 }}
                                        data-aos="fade-up"
                                    >
                                        <b>{product.name}</b>
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                        }}
                                    >
                                        Product of {product.country}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* View More Button */}
            <Box sx={{ marginTop: 4 }} data-aos="fade-up">
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#6A983C",
                        color: "#fff",
                        fontWeight: "bold",
                        "&:hover": {
                            backgroundColor: "#588b2a",
                        },
                        padding: "10px 20px",
                        borderRadius: "8px",
                        textTransform: "none",
                    }}
                    onClick={handleViewMoreClick}
                >
                    View More
                </Button>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 4,
                    mt: 6,
                }}
            >
                {features.map((feature, index) => (
                    <Box
                        key={index}
                        sx={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                        data-aos="zoom-in"
                    >
                        <Box
                            sx={{
                                width: 60,
                                height: 60,
                                backgroundColor: "#E2EAD3",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxShadow: 2,
                                fontSize: "24px",
                            }}
                        >
                            {feature.icon}
                        </Box>
                        <Typography variant="body1" sx={{ mt: 1, fontWeight: "bold" }}>
                            {feature.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default ImportedFoodProducts;
